import { useState, useEffect } from "react";
import { isOpenNow } from "@/lib/tracking";

export function OpenStatus() {
  const [status, setStatus] = useState<{ open: boolean; message: string } | null>(null);

  useEffect(() => {
    setStatus(isOpenNow());
    const interval = setInterval(() => setStatus(isOpenNow()), 60000);
    return () => clearInterval(interval);
  }, []);

  if (!status) return null;

  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${status.open ? "text-[#22c55e]" : "text-muted-foreground"}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${status.open ? "bg-[#22c55e] animate-pulse" : "bg-muted-foreground/50"}`} />
      {status.message}
    </span>
  );
}
